import { Alert, ModalButton, ModalContent, ModalFooter, useDialog } from '../../../Modal';

import React from 'react';
import styles from './DemoForm.module.scss';
import { useForm } from 'react-hook-form';

type Inputs = {
    firstName: string;
    lastName: string;
};

export default function DemoForm(): JSX.Element {
    const { register, handleSubmit, errors } = useForm<Inputs>();

    const dialog = useDialog<string>();
    const onSubmit = (data: Inputs) => {
        dialog.close(`Your name is ${data.firstName} ${data.lastName}`);
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
            <ModalContent className={styles.content}>
                <label>
                    <span>First name *: </span>
                    <input name="firstName" ref={register({ required: true })} />
                </label>
                <div className={styles.errorPlace}>
                    {errors.firstName && <span>First name is required</span>}
                </div>

                <label>
                    <span>Last name *: </span>
                    <input name="lastName" ref={register({ required: true })} />
                </label>
                <div className={styles.errorPlace}>
                    {errors.lastName && <span>Last name is required</span>}
                </div>
            </ModalContent>

            <ModalFooter>
                <ModalButton formRole="submit">Ok</ModalButton>
                <ModalButton
                    type="danger"
                    onClick={async () => {
                        dialog.close(undefined);
                    }}
                >
                    Cancel
                </ModalButton>
            </ModalFooter>
        </form>
    );
}
